import { TmElement, color, rem } from '@thiememeulenhoff/lit-sdk';
import { css, html } from 'lit';
import { customElement, property, state } from 'lit/decorators.js';
import { styleMap } from 'lit/directives/style-map.js';
import { tagName } from '../../helpers';

const tag = tagName('progress-circle');

const progressCircleStyles = css`
  :host {
    --circle-size: ${rem(24)};
    --circle-color: ${color('blue')};
    --circle-background: ${color('blue', 200)};
  }

  .circle {
    background: conic-gradient(
      var(--circle-color) 50%,
      var(--circle-background) 0
    );
    block-size: var(--circle-size);
    border-radius: var(--circle-size);
    display: inline-block;
    inline-size: var(--circle-size);
  }
`;

@customElement(tag)
export class ProgressCircleComponent extends TmElement {
  static override styles = progressCircleStyles;

  @property({ type: Number, reflect: true })
  @state()
  max = 5;

  @property({ type: Number, reflect: true })
  @state()
  value = 2;

  get progress() {
    return (this.value / this.max) * 100;
  }

  override render() {
    return html`
      <div
        class="circle"
        style=${styleMap({
          background: `conic-gradient(var(--circle-color) ${this.progress}%, var(--circle-background) 0)`,
        })}
      ></div>
      <slot></slot>
    `;
  }
}

declare global {
  interface HTMLElementTagNameMap {
    'a-progress-circle': ProgressCircleComponent;
  }
}
